<template>
    <Navbar class="sm:hidden"/>
    <Header @hiddenContent="hideContent = true" @showContent="hideContent = false" :showExtras="false" />
    <!-- :showBackButton="showBackButton"/> -->
    <div :class="{ 'sm:hidden' : hideContent }">
        <slot></slot>
        <Footer />
    </div>
</template>

<script>
import Footer from '@/Components/Footer.vue'
// import Header from '@/Components/UI/Nav/Header.vue'
// import Navbar from '@/Components/UI/Nav/NavbarDeslogada.vue'

export default {
    components: {
        Footer,
        // Header,
        // Navbar
    },

    data() {
        return {
            navigationOpenState: false
        }
    },

    computed: {
        navigationClasses(){
            return this.navigationOpenState ? 'left-0' : 'left-[-270px]'
        }
    },

    props: {
        showBackButton: Boolean,
        hideContent: Boolean,
    }
}
</script>
